import React from "react"
import {Accordion, AccordionDetails, AccordionSummary, Typography} from "@material-ui/core"
import {ExpandMore as ExpandMoreIcon, Info as InfoIcon} from "@material-ui/icons"

import {CustomerInstalmentOverrideResetActivityPayload} from "@indebted/api"

function InstalmentOverrideResetActivity(
	panelId: number,
	{
		Title,
		HappenedAt,
		Payload,
	}: {Title: string; HappenedAt: string; Payload: CustomerInstalmentOverrideResetActivityPayload},
	expanded: boolean,
	handleExpand: (panelID: number) => (event: any, isExpanded: boolean) => void,
	classes: {summary: string; activityContent: string; activityContentLabel: string; activityContentValue: string},
) {
	return (
		<Accordion expanded={expanded} onChange={handleExpand(panelId)}>
			<AccordionSummary expandIcon={<ExpandMoreIcon />}>
				<InfoIcon color="primary" />
				<Typography className={classes.summary}>
					{" "}
					<b>{Title}</b> - {HappenedAt}
				</Typography>
			</AccordionSummary>
			<AccordionDetails>
				{expanded && (
					<div className={classes.activityContent}>
						<div>
							<Typography className={classes.activityContentLabel}>Weekly Max Duration:</Typography>
							<Typography className={classes.activityContentValue}>
								{Payload.WeeklyMaxDuration}
							</Typography>
						</div>
						<div>
							<Typography className={classes.activityContentLabel}>Payment Amount:</Typography>
							<Typography className={classes.activityContentValue}>
								{Payload.Currency} {(Payload.PaymentAmount / 100).toFixed(2)}
							</Typography>
						</div>
						<div>
							<Typography className={classes.activityContentLabel}>Reset At Balance:</Typography>
							<Typography className={classes.activityContentValue}>
								{Payload.Currency} {(Payload.ResetAtBalance / 100).toFixed(2)}
							</Typography>
						</div>
						<div>
							<Typography className={classes.activityContentLabel}>Agent Email:</Typography>
							<Typography className={classes.activityContentValue}>{Payload.AgentEmail}</Typography>
						</div>
					</div>
				)}
			</AccordionDetails>
		</Accordion>
	)
}

export {InstalmentOverrideResetActivity}
